import { Injectable } from '@angular/core';
import { Feature, Point } from 'geojson';
import { Observable, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export type Result = Feature<
  Point,
  {
    name: string;
  }
>;

var results: Result[] = [
  {
    type: 'Feature',
    id: 1,
    properties: {
      name: 'first',
    },
    geometry: {
      type: 'Point',
      coordinates: [-49.368267059326165, -28.69167939458228],
    },
  },
];

@Injectable({
  providedIn: 'root',
})
export class ResultsService {
  private results$: Observable<Result[]>;
  private resultsByID$: Observable<Map<number, Result>>;

  constructor() {}

  fetch() {
    // Based on: https://dev.to/angular/how-to-cache-http-requests-in-angular-5c8i
    if (!this.results$) {
      // of() is supposed to, eventually, be replaced by
      // a call to an HttpClient instace's method
      this.results$ = of(results).pipe(shareReplay(1));
    }

    return this.results$;
  }
}
